export const validateIntervalDays = (startDate: string, endDate: string): { hasError: boolean; message?: string } => {
    const proposalExcelIntervalDays = parseInt(import.meta.env.VITE_PROPOSAL_EXCEL_INTERVAL_DAYS)

    if(!startDate || !startDate){
       return {
        hasError: true,
        message: 'Selecione a data inicial e a data final para continuar.'
       }
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (end < start) {
        return {
          hasError: true,
          message: 'A data final não pode ser anterior à data inicial.'
        }
    }

    const MAX_RANGE_MS = proposalExcelIntervalDays * 24 * 60 * 60 * 1000 - 1;
    const diff = end.getTime() - start.getTime();

    if (diff > MAX_RANGE_MS) {
       return {
        hasError: true,
        message: `O intervalo máximo permitido é de ${proposalExcelIntervalDays} dia${proposalExcelIntervalDays > 1 ? 's' : ''}.`
       }
    }

    return {
      hasError: false
    }
}